module.exports = require("./mn-MN.js");